import { publicRequest, userRequest } from "../requestMethods";

import {
  getRatingStart,
  getRatingSuccess,
  getRatingFailure,
} from "../redux/ratingRedux";


import { toast } from "react-toastify";

export const getLabRatings = async (dispatch, labId) => {
  dispatch(getRatingStart());
  try {
    console.log('i m fetcging my rating apii=======================')
    const res = await publicRequest.get(`labApi/labRatingsRoutes/getLabReviews/${labId}`);

    if (res.status === 200) {
      console.log(res, "res.data for categories");
      dispatch(getRatingSuccess(res.data.data));
    }
  } catch (err) {
    dispatch(getRatingFailure());
  }
};

export const updateRatingStatus = async (labId) => {
  try {
    const res = await userRequest.patch(`labApi/labRatingsRoutes/updateLabReview/${labId}`);
    return res;

  } catch (err) {
    console.log(err);
  }
};
